<template>
  <div>
    <Navigation />
    <div class="main-container">
      <div class="container is-fullhd">
        <h1 class="is-size-2">
          {{ type === "new" ? "create" : type | capitalize }}
          {{ singularItem[title] }}
        </h1>
      </div>
      <div class="container">
        <div class="columns">
          <div class="column is-two-thirds">
            <template v-for="(entry, i) in Object.entries(itemData)">
              <template
                v-if="
                  ![
                    'id',
                    'content',
                    'description',
                    'created',
                    'edited',
                    'tags',
                    'file',
                    'active',
                    'event_time',
                    'template'
                  ].includes(entry[0])
                "
              >
                <div class="columns" :key="'row-' + i">
                  <div
                    class="column is-one-third"
                    :key="'field-' + entry[0] + i"
                  >
                    <strong>
                      {{ entry[0] | cleanTitle | capitalize }}
                    </strong>
                  </div>
                  <div
                    class="column is-two-thirds has-text-left"
                    :key="'value-' + entry[0] + i"
                  >
                    <input
                      type="text"
                      class="input"
                      v-model="itemData[entry[0]]"
                      :disabled="entry[0] === 'image'"
                    />
                  </div>
                </div>
              </template>
              <template v-else-if="entry[0] === 'tags'">
                <div class="columns" :key="'row-' + i">
                  <div
                    class="column is-one-third"
                    :key="'field-' + entry[0] + i"
                  >
                    <strong>
                      {{ entry[0] | cleanTitle | capitalize }}
                    </strong>
                  </div>
                  <div
                    class="column is-two-thirds has-text-left"
                    :key="'value-' + entry[0] + i"
                  >
                    <div class="input-mock">
                      <vue-tags-input
                        v-model="tag"
                        :tags="tags"
                        @tags-changed="newTags => (tags = newTags)"
                      />
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="entry[0] === 'event_time'">
                <div class="columns" :key="'row-' + i">
                  <div
                    class="column is-one-third"
                    :key="'field-' + entry[0] + i"
                  >
                    <strong>
                      {{ entry[0] | cleanTitle | capitalize }}
                    </strong>
                  </div>
                  <div
                    class="column is-two-thirds has-text-left"
                    :key="'value-' + entry[0] + i"
                  >
                    <div>
                      <v-date-picker v-model="eventDate" />
                    </div>
                  </div>
                </div>
              </template>
              <template
                v-else-if="entry[0] === 'content' || entry[0] === 'template'"
              >
                <div class="columns" :key="'row-' + i">
                  <div class="column is-one-third" :key="'editor-' + i">
                    <p :key="'field-' + entry[0] + i">
                      <strong>
                        {{ entry[0] | cleanTitle | capitalize }}
                      </strong>
                    </p>
                  </div>
                  <div class="column">
                    <Editor
                      :key="'content-' + entry[0]"
                      :content="entry[1]"
                      @updateContent="updateContent"
                      style="width: 100%;"
                    />
                  </div>
                </div>
              </template>
              <template v-else-if="entry[0] === 'file'">
                <div class="columns" :key="'row-' + i">
                  <div class="column" :key="'file-row-' + i">
                    <p :key="'field-' + entry[0] + i">
                      <strong>
                        {{ entry[0] | cleanTitle | capitalize }}
                      </strong>
                    </p>
                  </div>
                  <div class="column" :key="'file-input-' + i">
                    <FileUpload @updateFile="updateFile" :file="entry[1]" />
                  </div>
                </div>
              </template>
              <template v-else-if="entry[0] === 'description'">
                <div class="columns" :key="'row-' + i">
                  <div class="column is-one-third" :key="'editor-' + i">
                    <p :key="'field-' + entry[0] + i">
                      <strong>
                        {{ entry[0] | cleanTitle | capitalize }}
                      </strong>
                    </p>
                  </div>
                  <div class="column is-two-thirds">
                    <textarea
                      :key="'description-' + entry[0]"
                      v-model="itemData[entry[0]]"
                      class="textarea"
                    ></textarea>
                  </div>
                </div>
              </template>
              <template v-else-if="entry[0] === 'active'">
                <div class="columns" :key="'row-' + i">
                  <div class="column is-one-third" :key="'field-' + i">
                    <p>
                      <strong>
                        {{ entry[0] | cleanTitle | capitalize }}
                      </strong>
                    </p>
                  </div>
                  <div class="column is-one-third" :key="'active-' + i">
                    <p class="has-text-left">
                      <button
                        class="button"
                        :class="{
                          'is-primary': entry[1],
                          'is-warning': !entry[1]
                        }"
                        @click="itemData[entry[0]] = !itemData[entry[0]]"
                      >
                        {{ entry[1] ? "Active" : "Inactive" }}
                      </button>
                    </p>
                  </div>
                </div>
              </template>
              <template v-else></template>
            </template>
          </div>
          <div
            class="column is-one-third"
            v-if="
              ![
                'agm',
                'subscriber',
                'bylaws',
                'galleries',
                'homepage'
              ].includes(title)
            "
          >
            <PostThumbnail
              @updatePostPhoto="updatePhoto"
              :img="itemData.image"
              :itemType="'photo'"
              @isUpdating="isUpdating"
            ></PostThumbnail>
          </div>
        </div>
        <div class="columns mt-1" v-if="!isCreating && title === 'galleries'">
          <div class="column mt-1 is-two-thirds">
            <GalleryUploader @updateGallery="updateGallery" />
            <template v-if="galleryData.length">
              <template v-for="(photo, i) in galleryData">
                <div class="photo-container" :key="'col-' + i">
                  <GalleryImage
                    @updateGalleryImage="updateGalleryImage"
                    :img="photo"
                    :index="i"
                    :key="'img-' + i"
                  />
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third"></div>
          <div class="column is-one-third">
            <p class="has-text-right">
              <span class="mb-1" style="display: block" v-if="!isCreating">
                <small>
                  <em>
                    {{ itemData.title | cleanTitle | capitalize }}
                    last edited
                    {{ itemData.edited | niceDate }}
                  </em>
                </small>
              </span>
              <button class="button is-success" @click="saveItemData" :disabled="isAddingPhoto">
                {{ isCreating ? "Create New" : "Update" }}
                {{ this.title | cleanTitle | capitalize }}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import Editor from "@/components/Editor.vue";
import PostThumbnail from "@/components/PostThumbnail.vue";
import FileUpload from "@/components/FileUpload.vue";
import GalleryUploader from "@/components/GalleryUploader.vue";
import GalleryImage from "@/components/GalleryImage.vue";
import singularItem from "@/helpers/singularItems.js";
import VueTagsInput from "@johmun/vue-tags-input";
import axios from "axios";
import moment from "moment";


export default {
  name: "Form",
  data() {
    return {
      item: {},
      gallery: [],
      singularItem: singularItem,
      isCreating: false,
      tag: "",
      tags: [],
      isAddingPhoto: false
    };
  },
  components: {
    Editor: Editor,
    PostThumbnail: PostThumbnail,
    FileUpload: FileUpload,
    GalleryUploader: GalleryUploader,
    GalleryImage: GalleryImage,
    Navigation: Navigation,
    VueTagsInput: VueTagsInput
  },
  mounted() {
    if (!Object.keys(this.itemData).length) this.getItemData();
  },
  methods: {
    isUpdating(value) {
      this.isAddingPhoto = value;
    },
    updateContent(value) {
      if (
        Object.keys(this.itemData).includes("content") ||
        Object.keys(this.itemData).includes("template")
      ) {
        if (Object.keys(this.itemData).includes("template"))
          this.itemData.template = value;
        else this.itemData.content = value;
      }
    },
    updateDescription(value) {
      if (Object.keys(this.itemData).includes("description")) {
        this.itemData.description = value;
      }
    },
    updatePhoto(value) {
      if (Object.keys(this.itemData).includes("image")) {
        this.itemData.image = value;
      }
    },
    updateFile(value) {
      if (Object.keys(this.itemData).includes("file")) {
        this.itemData.file = value;
      }
    },
    updateGallery(value) {
      if (!this.isCreating && this.title === "galleries") {
        console.log(value);
        const photo = {
          gallery_id: this.itemData.id,
          title: value,
          alt: "",
          file: value
        };
        if (JSON.stringify(this.galleryData).indexOf(value) === -1) {
          this.galleryData = this.galleryData.concat([photo]);
        }
      }
    },
    updateGalleryImage(payload) {
      this.galleryData[payload.index] = payload.value;
    },
    getItemData() {
      if (this.id) {
        axios
          .get(process.env.VUE_APP_SERVER + this.title + "/" + this.id)
          .then(res => {
            console.log(res);
            if (res.data && res.data.result && res.data.result.length) {
              this.itemData = res.data.result[0];
              this.tags = this.itemData.tags
                ? this.itemData.tags
                    .split(",")
                    .map(t => ({ text: t, tiClasses: "ti-valid" }))
                : [];
            }
          })
          .catch(error => {
            console.error(error);
          });
        if (!this.isCreating && this.title === "galleries") {
          axios
            .get(process.env.VUE_APP_SERVER + "gallery-photos/" + this.id)
            .then(res => {
              if (res.data && res.data.result) {
                this.galleryData = res.data.result;
                console.log("success");
              }
            })
            .catch(error => {
              console.error(error);
            });
        }
      } else {
        axios
          .get(process.env.VUE_APP_SERVER + "fields/" + this.title)
          .then(res => {
            if (res.data && res.data.result && res.data.result.length) {
              this.isCreating = true;
              const itemData = {};
              res.data.result.forEach(r => {
                itemData[r] = "";
              });
              this.itemData = itemData;
            }
          })
          .catch(error => {
            this.$noty.error(error);
          });
      }
    },
    saveItemData() {
      const updates = { ...this.itemData };
      if (this.tags.length) {
        updates.tags = this.tags.map(t => t.text).join(",");
      }
      const id = updates.id;
      if(this.isCreating) {
        Object.keys(updates).forEach(k => {
            if (!updates[k]) delete updates[k];
      });
      } else {
        delete updates['created'];
      }
      delete updates.id;
      let url = !this.isCreating
        ? process.env.VUE_APP_SERVER + this.title + "/update/" + id
        : process.env.VUE_APP_SERVER + this.title + "/add";
      axios
        .post(url, { details: updates })
        .then(res => {
          if (res.data && res.data.result && res.data.message === "Success") {
            if (this.isCreating) this.isCreating = false;
            this.$noty.success(
              this.title[0].toUpperCase() +
                this.title.substring(1) +
                " updated!"
            );
            if (this.isCreating) {
              setTimeout(() => {
                this.$router.replace({
                  name: "Form",
                  params: {
                    type: "edit",
                    id: res.data.result.id,
                    title: this.title
                  }
                });
              }, 500);
            }
            this.getItemData();
          }
        })
        .catch(() => {
          this.$noty.error("Couldn't update your " + this.title + ".");
        });
      if (
        !this.isCreating &&
        this.galleryData.length &&
        this.title === "galleries"
      ) {
        this.galleryData.forEach(gd => {
          const idExists = Object.keys(gd).includes("id");
          let url = idExists
            ? process.env.VUE_APP_SERVER + "photos/update/" + this.id
            : process.env.VUE_APP_SERVER + "photos/add/";
          axios
            .post(url, { details: gd })
            .then(res => {
              if (res.data.message === "Success") {
                this.$noty.sucess("Gallery Images saved!");
              }
            })
            .catch(error => {
              console.error(error);
            });
        });
      }
    }
  },
  computed: {
    title() {
      return this.$route.params.title;
    },
    type() {
      return this.$route.params.type;
    },
    id() {
      return this.$route.params.id;
    },
    itemData: {
      get() {
        return this.item;
      },
      set(value) {
        this.item = value;
      }
    },
    galleryData: {
      get() {
        return this.gallery;
      },
      set(value) {
        this.gallery = value;
      }
    },
    eventDate: {
      get() {
        return this.item.event_time
          ? new Date(this.item.event_time)
          : new Date();
      },
      value(value) {
        this.item.event_time = value;
      }
    },
    activeState() {
      return this.itemData.active
        ? "fas fa-check-square fa-2x has-text-success"
        : "fas fa-square";
    }
  },
  filters: {
    capitalize(value) {
      if (value && value !== "agm")
        return value[0].toUpperCase() + value.substring(1);
      else if (value && value === "agm") return value.toUpperCase();
      else return value;
    },
    cleanTitle(value) {
      if (value) return value.replace(/_/g, " ");
      else return value;
    },
    niceDate(value) {
      if (value) return moment(value).format("MMMM Do YYYY, h:mm a");
      else return value;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/basic.scss";

.active-status {
  display: inline-block;
  margin-top: 0.5rem;
  &:hover {
    cursor: pointer;
  }
}

.photo-container {
  width: calc((100% / 2) - 1rem);
  display: inline-block;
  margin: 0.5rem;
}
</style>
